import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import MainNavbar from './MainNavbar';
import { Loader } from 'react-feather';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import Content from './Content';

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    overflow: 'hidden',
  })
);

const DashboardLayoutWrapper = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
  })
);

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const DashboardLayout = ({ userStore }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(async () => {
    const isLoggedIn = await userStore.checkLogin();
    if (!isLoggedIn) {
      navigate('/', { replace: true });
    }

    setLoading(false);
  }, []);

  return (
    <DashboardLayoutRoot>
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            {loading ? (<Content title="" userStore={userStore}></Content>) : <Outlet />}
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

DashboardLayout.propTypes = {
  userStore: PropTypes.object
};

export default DashboardLayout;
